import React, { useEffect } from 'react';
import UserProfile from '../components/auth/UserProfile';
import LoginButton from '../components/auth/LoginButton';


const MainPage = () => {
  useEffect(() => {
    document.title = 'Welcome';
  }, []);
  
  return (
    <div className="main-page">
      <div className="main-page-content">
        <img 
          src="/PrismVial_Small.jpg.png" 
          alt="Prism Vial" 
          className="prism-main-logo"
        />
        <h1>Welcome to Pr<span className="chromatic-i">i</span>sm!</h1>
        <p>Your lab from every angle.</p>
        <div className="main-page-actions">
          <UserProfile/>
          <LoginButton/>
        </div>
      </div>
    </div>
  );
};

export default MainPage;
